'use client';

import {
  ToastContainer,
  toast,
  type TypeOptions,
  type Theme,
} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import styles from './Toast.module.scss';

interface IShowToastParams {
  type: 'error' | 'success';
  message: string;
}

interface ICloseButtonProps {
  closeToast: (e: React.MouseEvent<HTMLElement>) => void;
  type: TypeOptions;
  ariaLabel?: string;
  theme: Theme;
}

export const showToast = ({ type, message }: IShowToastParams) => {
  toast[type](message, {
    toastId: 'prospect-toast',
  });
};

const getIcon = {
  error: (
    <img
      width="30px"
      height="30px"
      src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/alert-error.svg`}
      alt=""
    />
  ),
  success: (
    <img
      width="20px"
      height="20px"
      src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/check-white.svg`}
      alt=""
    />
  ),
};

export const Toast = () => {
  const CloseButton = ({ closeToast }: ICloseButtonProps) => (
    <button type="button" onClick={closeToast}>
      Ok
    </button>
  );

  return (
    <ToastContainer
      className={styles.toast}
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      closeButton={CloseButton}
      icon={({ type }) => getIcon[type]}
    />
  );
};
